import TrashNote from '../../assets/icons/trash.svg';
import DownNote from "../../assets/icons/down-note.svg";
import UpNote from "../../assets/icons/up-note.svg";

const TrashButton = ({
                         cleanAll,
                         downAction,
                         upAction
                     }: {
    cleanAll: () => void,
    downAction: () => void,
    upAction: () => void
}) => {

    const DownButton = () => {
        return (
            <button className="bottom-action-button" onClick={downAction}>
                <img src={DownNote} style={{ transform: 'scaleY(-1)' }} alt=""/>
            </button>
        );
    };
    const UpButton = () => {
        return (
            <button className="bottom-action-button" onClick={upAction}>
                <img src={UpNote} alt=""/>
            </button>
        );
    };

    return (
        <div style={{ textAlign: 'right', marginRight: '2rem' }}>
            <DownButton/>
            <UpButton/>
            <button
                className="bottom-action-button"
                onClick={() => {
                    cleanAll();
                }}
            >
                <img src={TrashNote} alt="trash-note"/>
            </button>

        </div>
    );
};

export default TrashButton;
